import React from 'react';
import PropTypes from 'prop-types';
import { GDPR_REGIONS, GdprUtils } from '@cyberint/common-utils';
import { Icons } from '@cyberint/dsc';
import * as S from './styled';

const mapRegionToIcon = {
  [GDPR_REGIONS.EU]: Icons.EuRegion,
  [GDPR_REGIONS.US]: Icons.UsRegion,
  [GDPR_REGIONS.AU]: Icons.AuRegion,
  [GDPR_REGIONS.GLOBAL]: Icons.UsRegion
};

export const Region = ({ region }) => {
  const normalizedRegion = GdprUtils.normalizeRegion(region);
  const RegionIcon = mapRegionToIcon[normalizedRegion] || Icons.UsRegion;

  return (
    <S.RegionTitle>
      {region === GDPR_REGIONS.GLOBAL ? 'US' : normalizedRegion?.toUpperCase() || 'N/A'}
      {RegionIcon && <RegionIcon fontSize="16px" />}
    </S.RegionTitle>
  );
};

Region.propTypes = {
  region: PropTypes.string
};
